import { useRef, useState } from 'react';

export const useLocalState = (value) => {
  const prevValue = useRef(value);
  const [localValue, setLocalValue] = useState(value);

  if (value !== prevValue?.current) {
    prevValue.current = value;
    setLocalValue(value);
  }

  return [localValue, setLocalValue];
};
